import React, { useCallback, useState, useEffect } from 'react';

import classnames from 'classnames';

import * as toast from 'utils/toast';
import Loading from 'components/common/loading/Loading';

interface ImageViewerImage {
  src: string;
  alt: string;
}

interface ImageViewerProps {
  visible: boolean;
  onClose: () => void;
  image: ImageViewerImage;
}

const ImageViewer: React.FC<ImageViewerProps> = (props) => {
  const { visible, onClose, image } = props;

  const onKeyDown = useCallback((event: KeyboardEvent) => event.key === 'Escape' && onClose(), [onClose]);

  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    document.addEventListener('keydown', onKeyDown, false);
    document.body.style.overflow = visible ? 'hidden' : 'auto';
    return () => {
      document.removeEventListener('keydown', onKeyDown, false);
    };
  }, [onKeyDown, visible]);

  return (
    visible && (
      <div className="profile-image-wrapper">
        <span
          className="cross-btn"
          onClick={() => {
            onClose();
          }}
        ></span>
        {loading && (
          <div className="profile-loading-wrapper">
            <Loading className="profile-loading" />
          </div>
        )}
        <img
          className={classnames('profile-image-original', {
            'loaded-image': !loading,
          })}
          src={image.src}
          alt={image.alt}
          onLoad={() => {
            setLoading(false);
          }}
          onError={() => {
            toast.error({
              title: 'Error',
              message: 'Failed to load the image',
            });
          }}
        />
      </div>
    )
  );
};

export default ImageViewer;
